import React, { FC } from 'react'
import { Stack } from 'components/Stack'
import { Flex } from 'components/Flex'
import { Text } from 'components/Text'
import { CategoryPolygonLegend } from 'models/legend'
import styles from './CategoryPolygon.module.scss'

type CategoryPolygonProps = {
  data: CategoryPolygonLegend[]
}

export const CategoryPolygon: FC<CategoryPolygonProps> = ({ data }) => {
  return (
    <Stack space="small">
      {data.map((category, index) => (
        <Flex align="center" gap="sm" key={index}>
          <div
            style={{ backgroundColor: category.fill, borderColor: category.stroke }}
            className={styles.symbol}
          />
          <Text size="small">{category.name}</Text>
        </Flex>
      ))}
    </Stack>
  )
}

CategoryPolygon.displayName = 'CategoryPolygon'
